<template>
    <div v-loading="loading">
                <div class="top-button">
            <el-button class="add-btn" type="warning" icon="el-icon-plus" size="small" @click="createVisible =true">
            </el-button>
        </div>

        <el-table
                highlight-current-row
                stripe
                style="width:100%"
                :data="tableData"
                class="data-table">
            <el-table-column align="center" prop="serviceName" label="Sub Service Name"></el-table-column>

            <el-table-column label="Icon" align="center">
                <template slot-scope="s">
                    <img width="150px" v-if="s.row.icon" :src=" s.row.icon | pathFmt" alt="_"/>
                </template>
            </el-table-column>

            <el-table-column label="Status" align="center">
                <template slot-scope="s">
                    <el-tag v-if="s.row.status ===1" type="success">Normal</el-tag>
                    <el-tag v-if="s.row.status !==1" type="warning">Disabled</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="Action" width="300" align="center">
                <template slot-scope="s">
                    <el-button icon="el-icon-edit" size="small" type="primary" @click="openEdit(s.row.id)" style="margin-right: 5px;">Edit</el-button>
                    <el-button icon="el-icon-s-order" size="small" @click="openOptions(s.row.id)">Options</el-button>
                </template>
            </el-table-column>
        </el-table>

        <comm-service-create-dialog v-if="createVisible" :pid="pid"
                                    :visible.sync="createVisible"></comm-service-create-dialog>

        <comm-service-modify-dialog v-if="updateVisible" :id="editId"
                                    :visible.sync="updateVisible"></comm-service-modify-dialog>

        <comm-service-option-update v-if="optionVisible" :service-id="editId"
                                    :visible.sync="optionVisible"></comm-service-option-update>
    </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
    import commServiceCreateDialog from './CommServiceCreateDialog'
    import commServiceModifyDialog from './CommServiceModifyDialog'
    import commServiceOptionUpdate from './CommServiceOptionUpdate'
    import {listServiceByPid} from '@/api/HomeserviceApi'
    import {s3Url} from '../../../utils/Constants'

    export default {
        name: 'CommService',
        components: {
            commServiceCreateDialog,
            commServiceModifyDialog,
            commServiceOptionUpdate
        },
        data() {
            return {
                pid: this.$route.params.pid,
                tableData: [{title: 'Home', icon: '12', status: 1}],
                dialogForm: {},
                createVisible: false,
                updateVisible: false,
                optionVisible: false,
                editId: -1,
                loading: false
            }
        },
        methods: {
            loadSubServiceData() {
                this.loading = true
                listServiceByPid(this.pid).then(res => {
                    this.tableData = res.data
                }).then(this.loading = false)
            },
            openEdit(id) {
                this.editId = id
                this.updateVisible = true
            },
            openOptions(id) {
                this.editId = id
                this.optionVisible = true
            }
        },
        watch: {
            $route: {
                handler: function () {
                    this.pid = this.$route.params.pid
                    this.loadSubServiceData()
                },
                deep: true
            }
        },
        filters: {
            pathFmt(url) {
                return s3Url + url
            }
        },
        mounted() {
            this.loadSubServiceData()
        }
    }
</script>

<style scoped>
    .top-button {
        margin-top: 1rem;
        text-align: right;
        width: 100%;
        padding-bottom: 1.2rem;
    }

    .data-table {
        margin-top: 10px;
    }
</style>
